import { reactive } from 'vue'
import deepcopy from 'deepcopy'
import { IContainer } from '../../../json-parse/src/interface'
import { basicLayout } from '../../../json-parse/src/tools/register'
import { HELP_LINE_LENGTH } from '../../../json-parse/src/tools/const'

const clickElement: HTMLElement | undefined = undefined // 画布鼠标点击元素
const layoutAndDocumentMap = new WeakMap()  // 布局和dom元素的映射
interface IObj {
  [prop: string]: number
}
export interface ILineArrInfo {
  x: number[]
  y: number[]
}

export interface ILineObjInfo {
  x: (number | string)[]
  y: (number | string)[]
}
interface IeditState {
  // 当前画布绑定的全量数据
  mockData: any
  // 全局的布局信息
  globalLayout: IContainer | undefined
  // 左侧菜单栏拖出来的布局信息
  dropedLayout: IContainer | undefined
  // 画布鼠标点击布局对象
  clickLayout: IContainer | undefined
  // 画布鼠标拖动位置信息
  mouseLocation:
    | {
        originTop: number
        originLeft: number
        downTop: number
        downLeft: number
        [key: string]: number
      }
    | undefined
  // 激活对象四周可缩放的点
  dotrectInfo: IObj | undefined
  // 激活对象的x轴和y轴数组集合
  lineArrInfo: ILineArrInfo
  // 激活对象的x轴和y轴
  lineObjInfo: ILineObjInfo
}

const editState: IeditState = {
  mockData: undefined, // 当前画布绑定的本地模拟数据
  globalLayout: undefined, // 鼠标拖动时候布局对象
  dropedLayout: undefined, // 鼠标拖动时候布局对象
  mouseLocation: undefined, // 鼠标拖动时候的位置信息
  clickLayout: undefined, // 鼠标点击获取的布局对象
  dotrectInfo: {}, // 激活对象的八个点
  lineArrInfo: { x: [], y: [] }, // 激活对象的x轴和y轴的辅助线数组集合
  lineObjInfo: { x: [], y: [] } // 激活对象的x轴和y轴的辅助线信息
}

// 布局信息响应式
const state = reactive(editState)

const editInfo = {
  state,
  // 画布鼠标拖动元素
  clickElement,
  layoutAndDocumentMap,
  // 设置-本地编辑的模拟数据
  setMockData(obj: any) {
    state.mockData = obj
  },
  // 设置-全局布局对象
  setGlobalLayout(obj: IContainer | undefined) {
    state.globalLayout = obj ? obj : deepcopy(basicLayout)
  },
  // 设置-全局布局对象
  setDropedLayout(obj: IContainer | undefined) {
    state.dropedLayout = obj
  },
  // 设置-画布鼠标拖动位置信息
  setMouseLocation(info: { [key: string]: number } | undefined) {
    state.mouseLocation = info as any
  },
  // 设置-画布鼠标点击元素
  setClickElement(ele: HTMLElement | undefined) {
    editInfo.clickElement = ele as any
  },
  // 设置-画布鼠标点击布局对象
  setClickLayout(ele: IContainer | undefined) {
    state.clickLayout = ele
  },
  // 设置-激活对象的四周点
  setDotrectInfo() {
    if (!editInfo.clickElement) return
    const info = (editInfo.clickElement as any).getBoundingClientRect()
    state.dotrectInfo = info
    // x/y辅助线相关
    const targetX = [info.left, info.left + info.width / 2, info.left + info.width]
    const targetY = [info.top, info.top + info.height / 2, info.top + info.height]
    const { x: xArr, y: yArr } = editInfo.state.lineArrInfo
    const resObj: ILineObjInfo = {
      x: ['none', 'none', 'none'],
      y: ['none', 'none', 'none']
    }
    xouter: for (let i = 0; i < xArr.length; i++) {
      const outer = xArr[i]
      for (let index = 0; index < targetX.length; index++) {
        const inner = targetX[index]
        if (Math.abs(inner - outer) < HELP_LINE_LENGTH) {
          resObj.x[index] = outer
          break xouter
        }
      }
    }
    youter: for (let i = 0; i < yArr.length; i++) {
      const outer = yArr[i]
      for (let index = 0; index < targetY.length; index++) {
        const inner = targetY[index]
        if (Math.abs(inner - outer) < HELP_LINE_LENGTH) {
          resObj.y[index] = outer
          break youter
        }
      }
    }
    editInfo.setLineObjInfo(resObj)
  },
  // 删除辅助线
  deleteHelpLine() {
    const resObj: ILineObjInfo = {
      x: ['none', 'none', 'none'],
      y: ['none', 'none', 'none']
    }
    editInfo.setLineObjInfo(resObj)
  },
  // 设置-激活对象的x轴和y轴的辅助线数组集合
  setLineArrInfo(info: ILineArrInfo) {
    state.lineArrInfo = info
  },
  // 设置-激活对象的x轴和y轴的辅助线信息
  setLineObjInfo(info: ILineObjInfo) {
    state.lineObjInfo = info
  }
}

export default editInfo
